import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=fc60574a&scoped=true"
import script from "./Main.ts?vue&type=script&lang=ts&external"
export * from "./Main.ts?vue&type=script&lang=ts&external"
import style0 from "./Main.vue?vue&type=style&index=0&id=fc60574a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc60574a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc60574a')) {
      api.createRecord('fc60574a', component.options)
    } else {
      api.reload('fc60574a', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=fc60574a&scoped=true", function () {
      api.rerender('fc60574a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/pages/Main/Main.vue"
export default component.exports